module.exports = __webpack_public_path__ + "static/media/money.8c658eec.png";